import { render, staticRenderFns } from "./certificateReport.vue?vue&type=template&id=0820a30d&scoped=true&"
import script from "./certificateReport.vue?vue&type=script&lang=js&"
export * from "./certificateReport.vue?vue&type=script&lang=js&"
import style0 from "./certificateReport.vue?vue&type=style&index=0&id=0820a30d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0820a30d",
  null
  
)

export default component.exports